import suiteService from 'qreventos-suite/services';

class SuiteConfig {
  evento: number = 865;
  token: string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4SSt4d09sd2VOSjg4WkF5WUZtTS9rTT0=';
  clientId: string = 'a119c269-b135-4a85-8c9f-bc043df45486-865';

  public constructor() {
    suiteService.clientId = this.clientId;
    suiteService.token = this.token;
  }
}

export default new SuiteConfig();